import React from 'react';
import { useStyletron } from 'baseui';
import { useSetAtom } from 'jotai';
import type { SelectOptionT } from '../../../../../modernization-common/relationships';
import { dispatchAtom } from '../../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../../atoms/label-store-dispatch/events';
import { getAnnotationLabelIcon } from '../../side-panel-m4/utils/get-annotation-label-icon';
type AnnotationSelectLabelPropsT = {
  option: SelectOptionT;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};
export const AnnotationSelectLabel = ({
  option,
  onMouseEnter,
  onMouseLeave
}: AnnotationSelectLabelPropsT) => {
  const [css, theme] = useStyletron();
  return <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale400,
    width: '100%'
  })}>
      {getAnnotationLabelIcon(option.annotationLabel, 14)}
      <span>{option.label}</span>
    </div>;
};
export const getAnnotationSelectLabel = ({
  option
}: {
  option: Readonly<{
    [key: string]: unknown;
  }>;
}) => <AnnotationSelectLabel option={(option as SelectOptionT)} />;
export const HoverableAnnotationSelectLabel = ({
  option
}: AnnotationSelectLabelPropsT) => {
  const dispatch = useSetAtom(dispatchAtom);
  return <AnnotationSelectLabel option={option} onMouseEnter={() => {
    dispatch({
      type: EVENTS.FOCUS_ANNOTATION,
      annotationId: option.id
    });
  }} onMouseLeave={() => {
    dispatch({
      type: EVENTS.FOCUS_ANNOTATION,
      annotationId: null
    });
  }} />;
};
export const getHoverableAnnotationSelectLabel = ({
  option
}: {
  option: Readonly<{
    [key: string]: unknown;
  }>;
}) => <HoverableAnnotationSelectLabel option={(option as SelectOptionT)} />;